import React from 'react';
import type { LinkProps } from 'antd/es/typography/Link';
import type { ParagraphProps } from 'antd/es/typography/Paragraph';

import { BaseLink, BaseParagraph, BaseText, BaseTitle } from './styled';
import type { CustomTextProps, CustomTitleProps } from './types';

export type { CustomTextProps, CustomTitleProps } from './types';

export const Title = React.forwardRef<HTMLElement, CustomTitleProps>(({ level = 1, children, ...rest }, ref) => (
    <BaseTitle ref={ref} level={level} {...rest}>
        {children}
    </BaseTitle>
));

Title.displayName = 'Title';

export const Text = React.forwardRef<HTMLElement, CustomTextProps>(({ children, size, ...rest }, ref) => (
    <BaseText ref={ref} {...rest} size={size}>
        {children}
    </BaseText>
));
Text.displayName = 'Text';

export const Paragraph = React.forwardRef<HTMLElement, ParagraphProps>(({ children, ...rest }, ref) => (
    <BaseParagraph ref={ref} {...rest}>
        {children}
    </BaseParagraph>
));
Paragraph.displayName = 'Paragraph';

export const Link = React.forwardRef<HTMLAnchorElement, LinkProps>(({ children, ...rest }, ref) => (
    <BaseLink ref={ref} {...rest}>
        {children}
    </BaseLink>
));
Link.displayName = 'Link';
